import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import { useState } from 'react';
import { v4 } from 'uuid';

/**
 * Returns an ID that is stable across renders.
 * @param defaultExternalId - ID to be used instead of a randomly generated ID. This ID is only considered on mount, so changes to this ID are ignored.
 * @returns If an external ID is passed in, the external ID. Otherwise, a randomly generated ID.
 */

function useId(defaultExternalId) {
  var _useState = useState(function () {
    return defaultExternalId !== null && defaultExternalId !== void 0 ? defaultExternalId : v4();
  }),
      _useState2 = _slicedToArray(_useState, 1),
      currentId = _useState2[0];

  return currentId;
}

export { useId as default };
